import { lazy } from "react";

const Dashboard = lazy(() => import("../../../features/dashboard/DashboardPage"));

export const dashboardRoutes = [
  { path: "/dashboard", component: Dashboard, private: true },
];
